!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?t():"function"==typeof define&&define.amd?define(t):t()}(0,function(){"use strict";function e(e){var t=this.constructor;return this.then(function(n){return t.resolve(e()).then(function(){return n})},function(n){return t.resolve(e()).then(function(){return t.reject(n)})})}function t(e){return new this(function(t,n){function o(e,n){if(n&&("object"==typeof n||"function"==typeof n)){var f=n.then;if("function"==typeof f)return void f.call(n,function(t){o(e,t)},function(n){r[e]={status:"rejected",reason:n},0==--i&&t(r)})}r[e]={status:"fulfilled",value:n},0==--i&&t(r)}if(!e||"undefined"==typeof e.length)return n(new TypeError(typeof e+" "+e+" is not iterable(cannot read property Symbol(Symbol.iterator))"));var r=Array.prototype.slice.call(e);if(0===r.length)return t([]);for(var i=r.length,f=0;r.length>f;f++)o(f,r[f])})}function n(e){return!(!e||"undefined"==typeof e.length)}function o(){}function r(e){if(!(this instanceof r))throw new TypeError("Promises must be constructed via new");if("function"!=typeof e)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=undefined,this._deferreds=[],l(e,this)}function i(e,t){for(;3===e._state;)e=e._value;0!==e._state?(e._handled=!0,r._immediateFn(function(){var n=1===e._state?t.onFulfilled:t.onRejected;if(null!==n){var o;try{o=n(e._value)}catch(r){return void u(t.promise,r)}f(t.promise,o)}else(1===e._state?f:u)(t.promise,e._value)})):e._deferreds.push(t)}function f(e,t){try{if(t===e)throw new TypeError("A promise cannot be resolved with itself.");if(t&&("object"==typeof t||"function"==typeof t)){var n=t.then;if(t instanceof r)return e._state=3,e._value=t,void c(e);if("function"==typeof n)return void l(function(e,t){return function(){e.apply(t,arguments)}}(n,t),e)}e._state=1,e._value=t,c(e)}catch(o){u(e,o)}}function u(e,t){e._state=2,e._value=t,c(e)}function c(e){2===e._state&&0===e._deferreds.length&&r._immediateFn(function(){e._handled||r._unhandledRejectionFn(e._value)});for(var t=0,n=e._deferreds.length;n>t;t++)i(e,e._deferreds[t]);e._deferreds=null}function l(e,t){var n=!1;try{e(function(e){n||(n=!0,f(t,e))},function(e){n||(n=!0,u(t,e))})}catch(o){if(n)return;n=!0,u(t,o)}}var a=setTimeout;r.prototype["catch"]=function(e){return this.then(null,e)},r.prototype.then=function(e,t){var n=new this.constructor(o);return i(this,new function(e,t,n){this.onFulfilled="function"==typeof e?e:null,this.onRejected="function"==typeof t?t:null,this.promise=n}(e,t,n)),n},r.prototype["finally"]=e,r.all=function(e){return new r(function(t,o){function r(e,n){try{if(n&&("object"==typeof n||"function"==typeof n)){var u=n.then;if("function"==typeof u)return void u.call(n,function(t){r(e,t)},o)}i[e]=n,0==--f&&t(i)}catch(c){o(c)}}if(!n(e))return o(new TypeError("Promise.all accepts an array"));var i=Array.prototype.slice.call(e);if(0===i.length)return t([]);for(var f=i.length,u=0;i.length>u;u++)r(u,i[u])})},r.allSettled=t,r.resolve=function(e){return e&&"object"==typeof e&&e.constructor===r?e:new r(function(t){t(e)})},r.reject=function(e){return new r(function(t,n){n(e)})},r.race=function(e){return new r(function(t,o){if(!n(e))return o(new TypeError("Promise.race accepts an array"));for(var i=0,f=e.length;f>i;i++)r.resolve(e[i]).then(t,o)})},r._immediateFn="function"==typeof setImmediate&&function(e){setImmediate(e)}||function(e){a(e,0)},r._unhandledRejectionFn=function(e){void 0!==console&&console&&console.warn("Possible Unhandled Promise Rejection:",e)};var s=function(){if("undefined"!=typeof self)return self;if("undefined"!=typeof window)return window;if("undefined"!=typeof global)return global;throw Error("unable to locate global object")}();"function"!=typeof s.Promise?s.Promise=r:s.Promise.prototype["finally"]?s.Promise.allSettled||(s.Promise.allSettled=t):s.Promise.prototype["finally"]=e});
function getTopPosition(el) {
    var rect = el.getBoundingClientRect(),
        scrollTop = getScrollTop();
    return rect.top + scrollTop;
}

function getScrollTop () {
    return window.pageYOffset || document.documentElement.scrollTop;
}
const RevCountdown_EVENTS = {
    init: 'rev-countdown::init',
    started: 'rev-teaser::started',
    ended: 'rev-teaser::ended'
}

class RevCountdown {

    constructor($element,
                options = {
                    showText: false,
                    showDays: false,
                    showHours: true,
                    showMinutes: true,
                    showSeconds: false,
                }
    ) {

        /**
         * root element
         * @type {HTMLElement | jQuery}
         */
        this.$ELEMENT = $element instanceof jQuery ? $element : $($element);
        this.$COUNT = this.$ELEMENT.find('.js-rev-count');
        if (this.$COUNT.length <= 0) {
            this.$COUNT = this.$ELEMENT;
        }

        this.$DAYS = this.$COUNT.find('.js-rev-count-days');
        this.$HOURS = this.$COUNT.find('.js-rev-count-hours');
        this.$MINUTES = this.$COUNT.find('.js-rev-count-minutes');
        this.$SECONDS = this.$COUNT.find('.js-rev-count-seconds');

        this.DESTINATION_DATE = this.$ELEMENT.attr('data-date');
        this.STATE_CLASSES = {
            isDisplayed: 'is-displayed'
        }

        $('body').trigger(RevCountdown_EVENTS.init);
        this.start();
    }

    start() {
        const _this = this;
        // Set the date we're counting down to
        var countDownDate = Date.parse(_this.DESTINATION_DATE);
        $('body').trigger(RevCountdown_EVENTS.started);

        // Update the count down every 1 second
        var x = setInterval(function () {

            // Get today's date and time
            var now = new Date().getTime();

            // Find the distance between now and the count down date
            var distance = countDownDate - now;

            // If the count down is finished, write some text
            if (distance < 0) {
                clearInterval(x);
                $('body').trigger(RevCountdown_EVENTS.ended);
                return;
            }

            // Time calculations for days, hours, minutes and seconds
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            // Display the result in the element
            if (_this.$DAYS.length > 0) {
                if (days < 10) {
                    days = '0' + days;
                }
                _this.$DAYS.html(days)
            } else {
                hours = hours + (days * 24);
            }

            if (_this.$HOURS.length > 0) {
                if (hours < 10) {
                    hours = '0' + hours;
                }
                _this.$HOURS.html(hours);
            }

            if (_this.$MINUTES.length > 0) {
                if (minutes < 10) {
                    minutes = '0' + minutes;
                }
                _this.$MINUTES.html(minutes);
            }

            if (_this.$SECONDS.length > 0) {
                if (seconds < 10) {
                    seconds = '0' + seconds;
                }
                _this.$SECONDS.html(seconds)
            }
        }, 1000);
    }

    show() {
        const _this = this;
        _this.$ELEMENT.addClass(_this.STATE_CLASSES.isDisplayed);
    }

    hide() {
        const _this = this;
        _this.$ELEMENT.removeClass(_this.STATE_CLASSES.isDisplayed);
    }

}
const RevTeaser_EVENTS = {
    init: 'rev-teaser::init',
    fadeOut: 'rev-teaser::hidden',
    fadeIn: 'rev-teaser::opened'
};

class RevTeaser {

    constructor($element) {

        /**
         * root element
         * @type {HTMLElement | jQuery}
         */
        this.$ELEMENT = $element instanceof jQuery ? $element : $($element);
        this.$CLOSE_BTN = this.$ELEMENT.find('.js-rev-teaser-close-btn');
        this.$BACKGROUND = this.$ELEMENT.find('.js-rev-teaser-background');
        this.STATE_CLASSES = {
            isTransitioned: 'is-transitioned',
            isOpen: 'is-open'
        }
        this.SESSION_KEY = 'rev-teaser-was-shown';
        this.WAS_TRIGGERT = false;
        this.SHOW_ONLY_ONCE = true;
        this.$ELEMENT.hide();
        this.registerHooks();
    }

    registerHooks() {
        const _this = this;
        let $body = $('body');

        $body.trigger(RevTeaser_EVENTS.init);

        _this.$CLOSE_BTN.on('click', _ => {
            if (_this.isOpen) {
                _this.fadeOut();
            }
        })
        _this.$BACKGROUND.on('click', _ => {
            if (_this.isOpen) {
                _this.fadeOut();
            }
        })

        let scrollTop = getScrollTop();
        $(window).on('scroll', e => {
            var headerHeight = $('.abt-header').length > 0 ? $('.abt-header').outerHeight() : 100;
            if (scrollTop >= headerHeight) {
                if (_this.SHOW_ONLY_ONCE) {
                    if (_this.wasTriggert === false) {
                        _this.fadeIn();
                    }
                } else {
                    _this.fadeIn();
                }
            }
            scrollTop = getScrollTop();
        })
    }

    fadeIn() {
        const _this = this;
        _this.$ELEMENT.show();
        setTimeout(function () {
            _this.$ELEMENT.addClass(_this.STATE_CLASSES.isOpen);
            _this.setWasTriggert(true);
            $('body').triggerHandler(RevTeaser_EVENTS.fadeIn);
        }, 50);
    }

    fadeOut() {
        const _this = this;
        _this.$ELEMENT.removeClass(_this.STATE_CLASSES.isOpen);
        setTimeout(function () {
            _this.$ELEMENT.hide();
            $('body').triggerHandler(RevTeaser_EVENTS.fadeOut);
        }, 450);

    }

    get isOpen() {
        const _this = this;
        return _this.$ELEMENT.hasClass(_this.STATE_CLASSES.isOpen);
    }

    get wasTriggert() {
        const _this = this;

        if (window.sessionStorage.getItem(_this.SESSION_KEY)) {
            return window.sessionStorage.getItem(_this.SESSION_KEY) === 'true';
        }

        return _this.WAS_TRIGGERT;
    }

    setWasTriggert(wasTriggert) {
        const _this = this;
        _this.WAS_TRIGGERT = wasTriggert;

        if (_this.WAS_TRIGGERT) {
            window.sessionStorage.setItem(_this.SESSION_KEY, 'true');
        } else {
            window.sessionStorage.removeItem(_this.SESSION_KEY);
        }
    }

    get $element() {
        const _this = this;
        return _this.$ELEMENT;
    }

}
$(document).ready(function () {

    let revTeaser;
    let $revTeaser = $('.js-rev-teaser')
    if ($revTeaser.length > 0) {
        revTeaser = new RevTeaser($revTeaser[0])
    }

    $('.js-rev-countdown').each((i, countdown) => {
        new RevCountdown(
            countdown,
            {
                showText: true,
                showDays: true,
                showHours: true,
                showMinutes: true,
                showSeconds: false,
            }
        );
    })

    $('body').on(RevTeaser_EVENTS.fadeIn, event => {
        event.preventDefault();
        event.stopPropagation();
        $('body').addClass('rev-teaser-is-shown');
        setTimeout(function () {
            showContent(revTeaser.$element).then(_ => {
                setTimeout(function () {
                  revTeaser.fadeOut();
                  $('body').removeClass('rev-teaser-is-shown');
                }, 8500);
            })
        }, 1200);
    })


});

function showContent($teaser) {
    return new Promise(function (resolve, reject) {

        setTimeout(function () {
            showRevTitle($teaser);
        }, 50);

        setTimeout(function () {
            hideRevTitle($teaser)
        }, 3500);

        setTimeout(function () {
            scaleRevSignature($teaser)
        }, 3550);
        setTimeout(function () {
            moveRevSignature($teaser)
        }, 5200);
        setTimeout(function () {
            showRevCountdown($teaser)
        }, 5350);
        setTimeout(function () {
            showRevLink($teaser)
            resolve();
        }, 5900);
    });
}

function showRevTitle($teaser) {
    $teaser.find('.rev-title').addClass('is-displayed');
}

function hideRevTitle($teaser) {
    $teaser.find('.rev-title').removeClass('is-displayed');
}

function scaleRevSignature($teaser) {
    $teaser.find('.rev-signature').addClass('is-displayed');
}

function moveRevSignature($teaser) {
    $teaser.find('.rev-signature').addClass('is-moved');
}

function showRevCountdown($teaser) {
    $teaser.find('.rev-countdown').addClass('is-displayed');
}

function showRevLink($teaser) {
    $teaser.find('.rev-link').addClass('is-displayed');
}